import { useState, type FormEvent } from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { useLogin, useMe } from '../api/queries';
import { Spinner } from '../components/ui';
import { errorMessage } from '../lib/api';

function safeNext(next: string | null): string {
  // Only allow same-site relative paths to avoid open redirects.
  return next && next.startsWith('/') && !next.startsWith('//') ? next : '/admin';
}

export function LoginPage() {
  const [params] = useSearchParams();
  const { data: user, isPending } = useMe();
  const login = useLogin();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  if (isPending) return <Spinner />;
  if (user) return <Navigate to={safeNext(params.get('next'))} replace />;

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    login.mutate({ email, password });
  }

  return (
    <div className="login">
      <form className="card login-card" onSubmit={handleSubmit}>
        <div className="brand center">
          <span className="brand-mark">99</span> Client Forms
        </div>
        <h1>Sign in</h1>
        <label className="field">
          <span>Email</span>
          <input
            className="input"
            type="email"
            autoComplete="username"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label className="field">
          <span>Password</span>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {login.error && <div className="alert alert-error">{errorMessage(login.error)}</div>}
        <button className="btn btn-primary btn-block" disabled={login.isPending}>
          {login.isPending ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
